import { Spinner } from "@shopify/polaris"
import classNames from "classnames"
import { ReactNode } from "react"

interface IProps {
  loading?: boolean
  zIndex?: CSSStyleDeclaration["zIndex"]
  className?: string
  text?: ReactNode
  hScreen?: boolean
}

/**
 * 全屏加载效果
 * @param props
 * @constructor
 */
export default function FullScreenLoading({
  loading = true,
  zIndex = "100",
  className = "",
  text,
  hScreen = false,
}: IProps) {
  return loading ? (
    <div
      className={classNames([
        "flex items-center justify-center absolute top-0 bg-white bg-opacity-90 w-full flex-col",
        hScreen ? "h-screen" : "h-full",
        className,
      ])}
      style={{ zIndex }}
    >
      <div>
        <Spinner hasFocusableParent={false} />
      </div>
      {text && <>{text}</>}
    </div>
  ) : (
    <></>
  )
}
